import React from "react"
import { useTranslation } from "react-i18next"

import { ImageCaption } from "shared/ui/image-caption/ImageCaption"

import {
  InstallationReferenceProductInfoView,
  InstallationReferenceProductInfoViewModel
} from "../installation-reference-product-info/InstallationReferenceProductInfoView"

export interface InstallationReferenceTabContentViewModel {
  productInfoViewModel: InstallationReferenceProductInfoViewModel | null
  productImage: React.ReactNode
  detailImage: React.ReactNode
  roomImage: React.ReactNode
}

export const InstallationReferenceTabContentView = React.memo(
  ({
    roomImage,
    detailImage,
    productImage,
    productInfoViewModel
  }: InstallationReferenceTabContentViewModel) => {
    const { t } = useTranslation()
    return (
      <div className="installation-reference-tab-content">
        <div className="installation-reference-tab-content__room">
          <ImageCaption caption={t("InstallationReference.RoomImage")}>
            {roomImage}
          </ImageCaption>
        </div>
        <div className="installation-reference-tab-content__detail">
          <ImageCaption caption={t("InstallationReference.DetailImage")}>
            {detailImage}
          </ImageCaption>
        </div>
        <div className="installation-reference-tab-content__image">
          {productImage}
        </div>
        <div className="installation-reference-tab-content__product">
          {productInfoViewModel ? (
            <InstallationReferenceProductInfoView {...productInfoViewModel} />
          ) : null}
        </div>
      </div>
    )
  }
)
